import * as $ from 'jquery';

$(() => {
  $('.close').click(() => {
    $('.flash').hide();
  });
});
